import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfTax from './confTax/confTax'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import {connect} from 'react-redux'
import {getTaxes} from '../../containers/app/actions' 
import TopBar from "../utils/Topbar/TopBar.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Tax = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeTax,setActiveTax] = React.useState(false) 

  React.useEffect(() => {
    props.getTaxes(props.user._id)
  },[]);


  React.useEffect(() => {
    if(props.taxes) {
      let arr = [];
      arr = props.taxes.filter(val => {
        if(val.name.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false)
    }
  },[searchValue,props.taxes]);



  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteTax",
      data: {
        taxId: value._id,
        userId: props.user._id
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getTaxes(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.name,
        val.gst, 
        <React.Fragment>  
          <IconButton onClick={() => {
            setActiveTax(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>

          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}> 
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfTax
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getTaxes(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
        user={props.user}
      />}
      {activeTax && <ConfTax 
        type="EDIT"
        tax={activeTax} 
        open={editModal} 
        user={props.user}
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setActiveTax(false)
          props.getTaxes(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>

      <TopBar
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Tax</h4> 

              <div className={style.buttons}> 
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Tax</Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No","Name", "GST %","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  taxes: state.appReducer.taxes
})
export default withRouter(connect(mapStateToProps,{getTaxes})(Tax));